<template>
    <q-card :data-qs="`product-card-${id}`">
        <div class="card-image-container">
            <PreviewImage :image-src="imageSrc" :fallback-icon="fallbackIcon" />
        </div>
        <q-card-section class="section">
            <div class="title">
                {{ title }}
            </div>
            <slot name="content" />
        </q-card-section>
    </q-card>
</template>

<script setup lang="ts">
import PreviewImage from "@/shared/components/image-item/preview-image.vue";

defineProps<{
    id: string;
    title: string;
    imageSrc?: string;
    fallbackIcon: string;
}>();
</script>

<style lang="scss" scoped>
.q-card {
    box-shadow: $card-shadow;

    &:hover {
        box-shadow: $card-shadow-hover;
    }

    .card-image-container {
        width: 100%;
        aspect-ratio: 4 / 3;
    }

    .section {
        padding: 12px;
        .title {
            font-size: 16px;
            font-weight: 600;
            word-break: break-word;
        }
    }
}
</style>
